const liveMap = {
  layers: {
    title: 'Map Layer',

    filters: {
      powerType: {
        title: 'Charging Power',
        placeholder: 'Charging Power',
        options: {
          fast: 'Fast',
          slow: 'Slow',
          turbo: 'Turbo',
        },
      },

      operator: {
        title: 'Charge Point Operator',
      },

      connectorType: {
        title: 'Connector Type',
        placeholder: 'Connector Type',
        options: {
          EC_Type_1: 'IEC Type 1',
          IEC_Type_2_J1772: 'IEC Type 2 (J1772)',
          IEC_Type_2: 'IEC Type 2',
          IEC_Type_3: 'IEC Type 3',
          CHAOJI: 'CHAOJI',
          NEMA: 'NEMA',
          TESLA: 'TESLA',
          CHADEMO: 'CHADEMO',
          GBT: 'GBT',
        },
      },

      vehicles: {
        title: 'Vehicles',
      },
    },

    content: {
      traffic: {
        title: 'Traffic',
        description: 'Layer description explaining what we show on the map',
        mildlyhigher: 'Mildly Higher',
        trafficJam: 'Traffic Jam',
      },

      evsChargingPoints: {
        title: 'EVs Charging Points',
        description: 'Layer description explaining what we show on the map',
        chargingPointOptions: {
          fast: 'Fast Charging Point',
          slow: 'Slow Charging Point',
        },
      },

      heatMap: {
        title: 'Heat Map',
        description: 'Layer description explaining what we show nn the map',
        scaleOfDemand: 'Scale Of Demand',
      },

      dots: {
        title: 'Dots',
        description: 'Layer description explaining what we whow on the map',
        numberOfDemands: 'Number Of Demand',
      },

      tripsLiveStream: {
        title: 'Live Stream Of Trips',
        description: 'Layer description explaining what we show on the map',
        tripProgress: 'Trip Progress',
        pickUp: 'Pick Up',
        dropOff: 'Drop Off',
      },
    },
  },
};

export default liveMap;
